<div class="header-text">Employee & Incident Details</div>
<div class="row mb-3 mt-3">
    <div class="col-sm-6">
        <label class="form-label">Employee <span class="text-danger">*</span></label>
        <pictured-item-select-box [value]="incidentReport.employeeId" (valueChange)="onEmployeeChange($event)"
            [dataSource]="employeesDataSource" [readOnly]="isNotEmployee || isReadOnly"
            [validators]="isNotEmployee ? [] : [{type: 'required'}]">
        </pictured-item-select-box>
        <div class="mt-2">
            <dx-check-box [(value)]="isNotEmployee" text="Not an employee"
                (onValueChanged)="onNotEmployeeToggle($event.value)" [readOnly]="isReadOnly">
            </dx-check-box>
        </div>
    </div>
    <div class="col-sm-6">
        @if (!isNotEmployee) {
            <div class="d-flex flex-column justify-content-center mt-3">
                <div class="d-flex">
                    <strong class="text-muted me-2">Position ID:</strong>
                    <span>{{ this.employeePosition.positionId }}</span>
                </div>
                <div class="d-flex mt-1">
                    <strong class="text-muted me-2">Job Title Description:</strong>
                    <span>{{ this.employeePosition.jobTitleDescription | capitalCase }}</span>
                </div>
            </div>
        } @else {
            <div>
                <label class="form-label">Name <span class="text-danger">*</span></label>
                <dx-text-box stylingMode="filled" [(value)]="incidentReport.externalName" maxLength="100" placeholder="Enter name"
                    [readOnly]="isReadOnly">
                    <dx-validator>
                        <dxi-validation-rule max="100" type="required" message="Name is required"></dxi-validation-rule>
                    </dx-validator>
                </dx-text-box>
            </div>
        }
    </div>
</div>
<div class="row g-3">
    <div class="col-md-3">
        <label class="form-label">Incident Date: <span class="text-danger">*</span></label>
        <dx-date-box [(value)]="incidentReport.incidentDate" stylingMode="filled" [useMaskBehavior]="true"
            [displayFormat]="dateFormat" [readOnly]="isReadOnly">
            <dx-validator>
                <dxi-validation-rule type="required" message="Incident Date is required"></dxi-validation-rule>
            </dx-validator>
        </dx-date-box>
    </div>
    <div class="col-md-3">
        <label class="form-label">Incident Time: <span class="text-danger">*</span></label>
        <dx-date-box stylingMode="filled" type="time" dateSerializationFormat="HH:mm"
            [(value)]="incidentReport.incidentTime" pickerType="list" [readOnly]="isReadOnly"> 
            <dx-validator>
                <dxi-validation-rule type="required" message="Incident Time is required"></dxi-validation-rule>
            </dx-validator>
        </dx-date-box>
    </div>
    <div class="col-md-3">
        <label class="form-label">Place of Incident: <span class="text-danger">*</span></label>
        <dx-text-box stylingMode="filled" [(value)]="incidentReport.placeOfIncident" maxLength="100"
            [readOnly]="isReadOnly">
            <dx-validator>
                <dxi-validation-rule max="100" type="required"
                    message="Place of Incident is required"></dxi-validation-rule>
            </dx-validator>
        </dx-text-box>
    </div>
    <div class="col-md-3">
        <label class="form-label">Shift: <span class="text-danger">*</span></label>
        <dx-select-box [(value)]="incidentReport.shiftId" [dataSource]="shiftDataSource" displayExpr="name"
            valueExpr="id" [searchEnabled]="true" [showClearButton]="true" stylingMode="filled" placeholder="Select..."
            [readOnly]="isReadOnly">
            <dx-validator>
                <dxi-validation-rule type="required" message="Shift is required"></dxi-validation-rule>
            </dx-validator>
        </dx-select-box>
    </div>
</div>
<div class="row row-cols-1 row-cols-md-3 row-cols-lg-5 g-3 mt-1">
    <div class="col">
        <label class="form-label">Body Part Injured: <span class="text-danger">*</span></label>
        <dx-text-box stylingMode="filled" [(value)]="incidentReport.bodyPartInjured" maxLength="100"
            [readOnly]="isReadOnly" placeholder="Enter body part injured">
            <dx-validator>
                <dxi-validation-rule max="100" type="required"
                    message="Body Part Injured  is required"></dxi-validation-rule>
            </dx-validator>
        </dx-text-box>
    </div>
    <div class="col">
        <label class="form-label">EMS Called?: <span class="text-danger">*</span></label>
        <dx-select-box [(value)]="incidentReport.emsCalled" [items]="yesOrNoOptions" valueExpr="value"
            displayExpr="text" stylingMode="filled" [readOnly]="isReadOnly" placeholder="Select...">
            <dx-validator>
                <dxi-validation-rule type="custom" [validationCallback]="validateYesNo"
                    message="EMS Called is required"></dxi-validation-rule>
            </dx-validator>
        </dx-select-box>
    </div>
    <div class="col">
        <label class="form-label">First Aid Administered?: <span class="text-danger">*</span></label>
        <dx-select-box [(value)]="incidentReport.firstAidAdministered" [items]="yesOrNoOptions" valueExpr="value"
            displayExpr="text" stylingMode="filled" placeholder="Select..." [readOnly]="isReadOnly">
            <dx-validator>
                <dxi-validation-rule type="custom" [validationCallback]="validateYesNo"
                    message="First Aid Administered is required"></dxi-validation-rule>
            </dx-validator>
        </dx-select-box>
    </div>
    <div class="col">
        <label class="form-label">By whom: <span class="text-danger">*</span></label>
        <dx-text-box stylingMode="filled" [(value)]="incidentReport.byWhomFirstAidAdministered" maxLength="100"
            [readOnly]="isReadOnly">
            <dx-validator>
                @if (incidentReport.firstAidAdministered) {
                    <dxi-validation-rule type="required" message="By whom is required">
                    </dxi-validation-rule>
                }
                <dxi-validation-rule type="stringLength" [max]="100" message="Too long">
                </dxi-validation-rule>
            </dx-validator>
        </dx-text-box>
    </div>
    <div class="col">
        <label class="form-label">Lost Time?: <span class="text-danger">*</span></label>
        <dx-select-box [(value)]="incidentReport.lostTime" [items]="yesOrNoOptions" valueExpr="value" displayExpr="text"
            stylingMode="filled" [readOnly]="isReadOnly" placeholder="Select...">
            <dx-validator>
                <dxi-validation-rule type="custom" [validationCallback]="validateYesNo"
                    message="Lost Time is required"></dxi-validation-rule>
            </dx-validator>
        </dx-select-box>
    </div>
</div>